const $ = jQuery.noConflict()

var self = module.exports = {
  init: function() {
    self.events.mouseOver()
  },

  events: {
    mouseOver: function() {
    	var player;
    	function onYouTubePlayerAPIReady() {

    	    jQuery(document).find('.ytplayer').map( function(index, elem) {
    	 
    	        player = new YT.Player(jQuery(elem).attr('id'), {
    	            height: '360',
    	            width: '640',
    	            videoId: jQuery(elem).data('video-id'),
    	            playerVars: {
    	                loop: 1,
    	                controls: 1, 
    	                rel: 0,
    	                fs: 0,
    	                showinfo: 0,
    	                disablekb: 1,
    	            }
    	        });
    	 
    	        var playVideo = function(  event ) {
    	         
    	            let parent = jQuery(this).closest('.split__media');
    	            parent.find('.video__overlay').hide();
    	            
    	            event.data.playVideo();
    	        }

    	        jQuery(document).find(jQuery(elem).data('trigger')).bind('click', player, playVideo)

    	    });
    	}
    }
  },
}
